// extracted by mini-css-extract-plugin
export default {"messageContent":"BlockText_messageContent__4x3zm"};